import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';

const onLinkClick = (to, category) => () => {
  console.log('Outbound link', to, category);
  if (category) {
    ReactGA.set({ dimension4: category });
  }
  ReactGA.outboundLink({
    label: to,
  }, () => {});
  ReactGA.set({ dimension4: null });
};

const OutboundLinkInternal = ({ to, category, ...props }) => (
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  <Link to={to} target="_blank" {...props} onClick={onLinkClick(to, category)}/>
);

const mapStateToProps = ({ documents: { activeCategory } }) => ({ category: activeCategory && activeCategory.name });

const OutboundLink = connect(mapStateToProps)(OutboundLinkInternal);

const DocumentLink = ({ external, to, ...props }) => (
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  external ? <OutboundLink to={to} {...props}/> : <Link to={to} {...props}/>
);

export default DocumentLink;



// WEBPACK FOOTER //
// ./book/src/commons/components/document/table/DocumentLink.jsx